import { render, staticRenderFns } from "./restitusi.vue?vue&type=template&id=56b6161c&"
import script from "./restitusi.vue?vue&type=script&lang=js&"
export * from "./restitusi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports